import {React, useState} from 'react';
import {Grid,Box, Button,Paper, Stack,Typography} from '@mui/material';
import {Add, Groups, ArrowForwardIos} from '@mui/icons-material';
import '../../App.css'

import Popup from '../Popup';
import LeaveDataMasterTable from '../table-data/LeaveDataMasterTable';
import LeaveDataMaster from './LeaveDataMaster';
import ViewEarningComponents from './ViewEarningComponents';

function ViewEmployeeLeaves(props){

  const [openPopup1, setOpenPopup1] = useState(false);
  const [openPopup2, setOpenPopup2] = useState(false);

  const convertToDefEventPara = (name, value) => ({
    target: {
      name: name,
      value: value
    }
  })

  const handleSubmit = (e) => {
    e.preventDefault();
  }

  // Function to close the modal from child component
  const handleCloseModal = () => {
    setOpenPopup1(false);
  };

  return(
    <Box sx={{display: "flex" ,justifyContent: "center", margin: "10px", marginTop: "-30px", padding: "30px", fontWeight: "500px"}}>
      <Paper elevation={0}>
        <Grid className="form-title" style={{marginBottom: "-60px"}} container spacing={2}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>View Leaves</Typography> </Grid>
          <Grid item> <Groups style={{marginLeft: "-30px"}} sx={{width: 45, height: 45}}/> </Grid>
        </Grid>
        <form autoComplete="off" onSubmit={handleSubmit}>
            <Stack spacing={2} sx={{margin: "30px"}}>

            <Stack display="flex" sx={{alignItems: "flex-end" }}>
                          <Button
                          style={{width: "130px"}}
                            className="form-btn"
                            variant="outlined"
                            color="success"
                            onClick={() => setOpenPopup1(true)}
                            startIcon={<Add sx={{ width: "24px", height: "24px" }} />} // Use a reasonable size here
                            sx={{
                              whiteSpace: "nowrap",
                              textTransform: "none"
                            }}
                          >
                            Add Leave
                          </Button>
                        </Stack>

            <LeaveDataMasterTable employeeID={props.employeeID} fetch_id={props.fetch_id} />

            <Stack className="end-align" >
                    <Button className="form-btn" variant="outlined" onClick={() => setOpenPopup2(true)} endIcon={<ArrowForwardIos/>} >Next</Button>
            </Stack>

            </Stack>
        </form>

        <Popup
          title="Add"
          openPopup={openPopup1}
          setOpenPopup={setOpenPopup1}
        >
          <LeaveDataMaster 
            title="Add Employee Leave" 
            employeeID={props.employeeID} 
            fetch_id={props.fetch_id}
            onCloseModal={handleCloseModal}
          />
        </Popup>

        <Popup
          title="Earning Components"
          openPopup={openPopup2}
          setOpenPopup={setOpenPopup2}
        >
          <ViewEarningComponents employeeID={props.employeeID} fetch_id={props.fetch_id} />
        </Popup>

      </Paper>
    </Box>
  )
}

export default ViewEmployeeLeaves;